module.exports = __webpack_public_path__ + "static/media/sort-arrows-white.c78d193b.png";